
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSingleTransport, updateTransportEntry } from '../../Store/PHPSlice/Transport';
import { useParams } from 'react-router-dom';


const TransportEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        transportId: parseInt(Id),
        transportNm: '',
        contact: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singleTransport = useSelector((state) => state.TransportData.singleTransport || { data: [] });
    useEffect(() => {
        dispatch(fetchSingleTransport(Id));
    }, [dispatch, Id]);
    useEffect(() => {
        if (singleTransport.data.length > 0) {
            const item = singleTransport.data[0];
            setFormData({
                ...formData,
                transportNm: item.transportNm,
                contact: item.contact
            });
        }
    }, [singleTransport]);
    console.log(singleTransport)
    if (!singleTransport) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };



    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(formData);
        // Validate department name
        // if (!formData.rackNm.trim()) {
        //     setErrors({ rackNm: 'Rack Name is required' });
        //     return;
        // }

        dispatch(updateTransportEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Transport Added");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };






    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Transport Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>

                                {[
                                    { label: 'Transport Name', name: 'transportNm' },
                                    { label: 'Contact', name: 'contact' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>


            </div>
        </>
    );
}

export default TransportEdit;
